
import { defineComponent, ref } from "vue";
import Permission from "@/core/config/Permission";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import { reFormatCurrent } from "./scholarship.vue";
import { sortByAlphabet } from "@/core/helpers/sortHelpers";
import { exportStyledXlsx, formatMoneyVN, XlsxColumn } from "@/core/helpers/exportXlsx";

interface ICustomer {
    id: string;
    certificateName: string;
    certificateCode: string;
    minScore: number;
    maxScore: number;
    freeSubjects: string;
}
interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface IData {
    id: string;
    certificateName: string;
    certificateCode: string;
    variantLabel?: string;
    value: string;
    activationcriteria: [];
    appliedprograms: []
    description: string;
    ismulticriteria: boolean
    type: string
    nextlevel: any
}
export function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
    } else {
        return true;
    }
}
export function formatCurrent(value) {
    // FIX zero-value: dùng ?? để value=0 KHÔNG rơi khỏi if (trước: 0||'' = '' -> trả undefined -> vòng load→save biến 0 thành NULL trong DB). Blank/null vẫn trả blank.
    let formated = (value ?? '').toString()
    if (formated != '') {
        return (+formated.replaceAll('.', '')).toLocaleString('vi-VN')
    }
}
export default defineComponent({
    name: "Combination-code",
    components: {
        Datatable,
    },
    data() {
        return {
        }
    },
    methods: {
        isNumber (evt) {
            return isNumber(evt)
        },
        formatCurrentMoney(evt,value) {
            if (isNumber(evt)) {
                let formated = (value||'').toString()
                if (formated != '') {
                    return (+formated.replaceAll('.', '')).toLocaleString('vi-VN') ? (+formated.replaceAll('.', '')).toLocaleString('vi-VN') : ""
                }
            }
        },
        removeRow(index) {
            if(this.arrCondition.length >1) {
                this.arrCondition = this.arrCondition.filter((i,ind) =>ind != index)
            }
        },
        exportFile() {
            // Xuất Excel phía FE có style — dùng helper chung exportStyledXlsx (mẫu promotion.vue)
            const columns: XlsxColumn[] = [
                { label: "Tên chứng chỉ", width: 28, wrap: true },
                { label: "Mã chứng chỉ", width: 16 },
                { label: "Loại", width: 12, align: "C" },
                { label: "Chương trình áp dụng", width: 20, wrap: true },
                { label: "Điều kiện áp dụng", width: 28, wrap: true },
                { label: "Mã môn miễn giảm", width: 16 },
                { label: "Tên môn miễn giảm", width: 30, wrap: true },
                { label: "Giá trị giảm", width: 14, align: "R" },
                { label: "Mô tả môn", width: 30, wrap: true },
                { label: "Môn học tiếp theo", width: 34, wrap: true },
                { label: "Mô tả điều kiện", width: 40, wrap: true },
            ]
            const conditionText = (item: any) => {
                const criteria = (Array.isArray(item.activationcriteria) ? item.activationcriteria : [])
                    .filter((i: any) => (i.min !== '' && i.min != null) || (i.max !== '' && i.max != null))
                    .map((i: any) => {
                        const typeLabel = this.optionsTypeCondition.find((o: any) => o.value == i.type)?.label
                        return `[${i.min} ~ ${i.max}]${typeLabel ? ` ${typeLabel}` : ''}`
                    })
                return criteria.join(item.ismulticriteria ? ' VÀ ' : '; ')
            }
            try {
                const rows: any[][] = []
                const rowGroups: number[] = [] // index điều kiện của từng dòng -> tô nền xen kẽ theo NHÓM
                this.tableData.forEach((item: any, groupIdx: number) => {
                    const programs = (Array.isArray(item.appliedprograms) ? item.appliedprograms : [])
                        .map((p: string) => this.optionsPrograms.find((o: any) => o.value == p)?.label || p)
                    // nextlevel trong tableData còn giá trị RAW (chưa formatCurrent) -> formatMoneyVN
                    const nextLevelText = (Array.isArray(item.nextlevel) ? item.nextlevel : [])
                        .filter((i: any) => i.name || i.code)
                        .map((i: any) => `${i.name || i.code}${i.value !== '' && i.value != null ? ` (${formatMoneyVN(i.value)})` : ''}`)
                        .join(', ')
                    // Cột chung của điều kiện (lặp lại trên mỗi dòng môn miễn giảm)
                    const baseCols = [
                        item.certificateName || '',
                        item.certificateCode || '',
                        this.arrType.find((o: any) => o.value == item.type)?.label || item.type || '',
                        programs.length ? programs.join(', ') : 'Tất cả',
                        conditionText(item),
                    ]
                    const pushRow = (s: { code: string; name: string; value: string; description: string }) => {
                        rows.push([...baseCols, s.code, s.name, s.value, s.description, nextLevelText, item.description || ''])
                        rowGroups.push(groupIdx)
                    }
                    // value môn miễn giảm ĐÃ format vi-VN từ mounted -> giữ nguyên
                    const subjects = Array.isArray(item.courseexemptions) ? item.courseexemptions : []
                    subjects.forEach((s: any) => {
                        pushRow({
                            code: s.code || '',
                            name: s.name || '',
                            value: s.value !== '' && s.value != null ? String(s.value) : '',
                            description: s.description || '',
                        })
                    })
                    // Điều kiện chưa cấu hình môn nào -> vẫn xuất 1 dòng để không sót
                    if (!subjects.length) {
                        pushRow({ code: '', name: '(Chưa cấu hình môn miễn giảm)', value: '', description: '' })
                    }
                })

                exportStyledXlsx({
                    title: 'DANH SÁCH ĐIỀU KIỆN MIỄN GIẢM TIẾNG ANH',
                    summary: `Tổng: ${this.tableData.length} điều kiện (${rows.length} dòng môn miễn giảm)`,
                    sheetName: 'Điều kiện Tiếng Anh',
                    fileBaseName: 'dieu-kien-mien-giam-tieng-anh',
                    columns,
                    rows,
                    rowGroups,
                })
            } catch (error) {
                console.log('err', error)
                Swal.fire({
                    text: 'Không thể xuất file Excel.',
                    icon: 'error',
                    buttonsStyling: false,
                    confirmButtonText: 'Đóng',
                    customClass: { confirmButton: 'btn btn-primary' },
                })
            }
        },
        checkMultiForm(e: any) {
            // console.log('e',e,this.formData.ismulticriteria)
            this.arrCondition = []
            if(e) {
                let a = [1,2,3]
                a.forEach((i: any) => {
                    let temp = {
                        min: "",
                        max: "",
                        type: "",
                    }
                    this.arrCondition.push(temp)    
                })
            }
            else {
                this.addNewRow()
            }
        },
        addNewRow() {
            let temp = {
                min: "",
                max: "",
                type: "",
            }
            this.arrCondition.push(temp)
        },
        
        addNewRowSubject() {
            let temp = {
                code: "",
                name: "",
                value: "",
                description: "",
            }
            this.arrSubject.push(temp)
        },
        removeRowSubject(index) {
            if(this.arrSubject.length >1) {
                this.arrSubject = this.arrSubject.filter((i,ind) =>ind != index)
            }
        },
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            let temp = {
                "id": '',
                "certificateName": "",
                "certificateCode": "",
                "variantLabel": "",
                value: "",
                activationcriteria: [],
                appliedprograms: [],
                "description": "",
                courseexemptions: [],
                type: "1",
                nextlevel: [
                {
                    name: "",
                    code: "",
                    value: "",
                    description: "",
                   
                },{
                    name: "",
                    code: "",
                    value: "",
                    description: "",
                   
                }
                ]
            } as any
            this.arrCondition = [{
                min: "",
                max: "",
                type: "",
            }]
            this.arrSubject = [{
                code: "",
                name: "",
                value: "",
                description: "",
                ismulticriteria: false,
            }]
            this.formData = temp
        },
        async duplicateRow(record) {
            let tempData = record
            delete tempData.id
            if(tempData.courseexemptions) {
                tempData.courseexemptions = tempData.courseexemptions.map((i: any) =>({...i, value: i.value && reFormatCurrent(i.value)}))
            }
            // console.log('tempData',tempData)
            await axios.post(`/setting/freesubject`, tempData)
            .then(async () => {
                await this.getData()
                Swal.fire({
                    html: 'Success completed',
                    icon: 'success',
                    buttonsStyling: false,
                    confirmButtonText: "Đóng",
                    timer: 300,
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                })
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa điều kiện này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`/setting/freesubject/${record.id}`).then(() => this.getData())
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            this.resetDataForm()
            this.idFormEdit = record.id
            await axios.get(`/setting/freesubject/${record.id}`)
                .then(({ data }) => {
                    data.value = formatCurrent(data.value)
                    let nextlevel = [
                    {
                        name: "",
                        code: "",
                        value: "",
                        description: "",
                    },
                    {
                        name: "",
                        code: "",
                        value: "",
                        description: "",
                    }
                    ]
                    // console.log('data',data)
                    if(data.nextlevel && Array.isArray(data.nextlevel)) {
                        data.nextlevel.forEach((e)=> {
                            e.value = formatCurrent(e.value)
                        })
                    }
                    else {
                        data.nextlevel = nextlevel
                    }
                    data.type = data.type?data.type:'' 
                    // console.log('data',data)
                    data.ismulticriteria = data.ismulticriteria?data.ismulticriteria:false
                    this.formData = data
                    this.arrCondition = data.activationcriteria||[{
                        min: '',
                        max: '',
                        type: '',
                    }]
                    data.courseexemptions
                    this.arrSubject = data.courseexemptions?.map((i: any) =>({...i,value: formatCurrent(i.value)}))||[{
                        code: '',
                        name: '',
                        value: '',
                        description: '',
                    }]
                    this.isEdit = true
                    this.kt_modal_add_combination?.click()
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        }
    },

    async mounted() {
        //Danh sách nạp qua getData() (định nghĩa trong setup) để mọi thao tác đều đi qua một nguồn
        await (this as any).getData()
    },
    setup() {
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const isEdit = ref(false);
        const idFormEdit = ref('');
        const arrType = ref<any>(
            [
                {
                    label: "THPT",
                    value: "1",
                },
                {
                    label: "Chứng chỉ",
                    value: "2",
                }
            ]
        )
        const arrCondition = ref<any>([
            {
                min: "",
                max: "",
                type: "",
            }
        ])
        const arrSubject = ref<any>([
            {
                code: "",
                name: "",
                value: "",
                description: "",
            }
        ])
        
        const optionsPrograms = ref([
            {
                label: "Song Ngữ",
                value: "SONG_NGU",
            },
            {
                label: "Tiếng Việt",
                value: "TIENG_VIET",
            },
        ])
        const optionsTypeCondition = ref([
            {
                label: "Nghe và đọc",
                value: "nghe-va-doc",
            },
            {
                label: "Viết",
                value: "viet",
            },
            {
                label: "Nói",
                value: "noi",
            },
        ])
        const pagination = ref<IPagination>({
            currentPage: 1,
            total: 0,
            limit: 1000,
        });
        const tableHeader = ref([
            {
                name: "Chứng chỉ",
                key: "certificateName",
                class: 'min-w-200px',
                sortable: true,
            },
            {
                name: "Chương trình",
                key: "appliedprograms",
                class: 'min-w-120px',
                sortable: false,
            },
            {
                //sortable:false — cột render từ mảng activationcriteria, sortByAlphabet sẽ throw
                name: "Ngưỡng điểm",
                key: "minScore",
                class: 'min-w-110px',
                sortable: false,
            },
            {
                name: "Miễn giảm",
                key: "freeSubjects",
                class: 'w-100',   //cột co giãn: chiếm phần trống còn lại thay vì để khoảng hở giữa bảng
                sortable: false,
            },
            {
                name: "HÀNH ĐỘNG",
                key: "actions",
                sortable: false,
                class: "text-center min-w-120px"
            },
        ]);
        const formData = ref<IData>({
            "id": '',
            "certificateName": "string",
            "certificateCode": "string",
            value: "",
            activationcriteria: [],
            appliedprograms: [],
            "description": "",
            ismulticriteria: false,
            type: "1",
            nextlevel: [
            {
                name: "",
                code: "",
                value: "",
                description: ""
            },
            {
                name: "",
                code: "",
                value: "",
                description: ""
            }
            ]
        })
        const tableData = ref<Array<ICustomer>>([]);
        //initRows = dữ liệu gốc từ server; tableData = phần đang hiển thị sau tìm kiếm/lọc
        const initRows = ref<any[]>([]);
        const search = ref('');
        const filterType = ref('');
        const filterProgram = ref('');
        //NGUỒN DUY NHẤT dựng bảng: mounted + sau mỗi lần Lưu/Nhân bản/Xóa đều gọi hàm này
        async function getData() {
            await axios.get(`/setting/freesubject`)
                .then(({ data }) => {
                    sortByAlphabet(data || [], 'certificateName').forEach((item: any) => {
                        if (item.courseexemptions) {
                            item.courseexemptions = item.courseexemptions?.map((i: any) => ({ ...i, value: i.value && formatCurrent(i.value.toString()) }))
                        }
                    })
                    //Cùng một chứng chỉ có nhiều dòng, chỉ khác NGƯỠNG ĐIỂM -> xếp theo ngưỡng tăng dần
                    //trong từng chứng chỉ, đọc thành thang điểm liền mạch (trước đây thứ tự ngẫu nhiên).
                    const minOf = (r: any) => {
                        const c = (r.activationcriteria || []).filter((i: any) => i.min)
                        return c.length ? Math.min(...c.map((i: any) => +i.min || 0)) : Number.MAX_SAFE_INTEGER
                    }
                    const rows = [...(data || [])].sort((a: any, b: any) => {
                        const n = String(a.certificateName || '').localeCompare(String(b.certificateName || ''), 'vi')
                        return n !== 0 ? n : minOf(a) - minOf(b)
                    })
                    initRows.value = rows
                    applyFilter()
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        }
        //Điều kiện của 1 dòng, xếp theo THỨ TỰ KỸ NĂNG CỐ ĐỊNH (nghe-và-đọc -> viết -> nói theo
        //optionsTypeCondition). Dữ liệu nhập vào lộn xộn nên nếu render y nguyên thì mỗi hàng một thứ tự,
        //mắt không đối chiếu được giữa các mức điểm.
        function sortedCriteria(row: any) {
            const order = (t: any) => {
                const i = optionsTypeCondition.value.findIndex((o: any) => o.value == t)
                return i === -1 ? 99 : i
            }
            return (row?.activationcriteria || [])
                .filter((i: any) => i.min)
                .slice()
                .sort((a: any, b: any) => order(a.type) - order(b.type))
        }
        //Tìm kiếm + 2 bộ lọc dùng CHUNG một hàm, luôn dựng lại từ initRows để lọc chồng nhau được
        function applyFilter() {
            let rows = [...initRows.value]
            const kw = search.value.trim().toUpperCase()
            if (kw) {
                rows = rows.filter((r: any) => {
                    const hay = [r.certificateName, r.certificateCode, r.description,
                        ...(r.courseexemptions || []).map((i: any) => `${i.code} ${i.name}`),
                        ...(r.nextlevel || []).map((i: any) => `${i.code} ${i.name}`)]
                        .filter(Boolean).join(' ').toUpperCase()
                    return hay.indexOf(kw) !== -1
                })
            }
            if (filterType.value) {
                rows = rows.filter((r: any) => String(r.type ?? '') === filterType.value)
            }
            if (filterProgram.value) {
                //Chương trình rỗng = áp cho TẤT CẢ -> vẫn khớp mọi lựa chọn
                rows = rows.filter((r: any) => !(r.appliedprograms || []).length || (r.appliedprograms || []).includes(filterProgram.value))
            }
            tableData.value = rows as any
        }
        const arrMajors = ref([]) as any;
        const formRef = ref<HTMLFormElement | null>(null);
        const checkNumber = (rule: any, value: any, callback: any) => {
            if (!value) {
                return callback(new Error('Vui lòng điền trường này'))
            }
            setTimeout(() => {
                if (!Number.isInteger(value)) {
                    callback(new Error('Vui lòng nhập các chữ số'))
                } else {
                    callback()
                }
            }, 1000)
        }
        const rules = ref({
            certificateName: [{
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change"
            }],
            minScore: [{ validator: checkNumber, trigger: 'blur' }],
            maxScore: [{ validator: checkNumber, trigger: 'blur' }],
        })
        const submit = () => {
            if (!formRef.value) { return; }
            formRef.value.validate(async (valid) => {
                if (valid) {
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    formData.value.nextlevel.forEach((e) => {
                        e.value = reFormatCurrent(e.value)
                    }) //.value = reFormatCurrent(formData.value.nextlevel.value)
                    let data = {
                        "certificateName": formData.value.certificateName != "" ? formData.value.certificateName : undefined,
                        "certificateCode": formData.value.certificateCode != "" ? formData.value.certificateCode : undefined,
                        
                        "description": formData.value.description != "" ? formData.value.description : undefined,
                        "activationcriteria": arrCondition.value,
                        "courseexemptions": arrSubject.value.map((i: any) => ({...i,value: reFormatCurrent(i.value)})),
                        "value": reFormatCurrent(formData.value.value),
                        "appliedprograms": formData.value.appliedprograms,
                        "ismulticriteria": formData.value.ismulticriteria,
                        type: formData.value.type,
                        nextlevel: formData.value.nextlevel,

                    }
                    await axios[method](`/setting/freesubject${id}`, data)
                        .then(async () => {
                            //Nạp lại từ server thay vì vá 1 dòng: giữ đúng thứ tự + bộ lọc đang bật
                            await getData()
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });

                } else {
                    return false;
                }
            });
        };
        return {
            kt_modal_add_combination,
            formRef,
            rules,
            addCombinationModalRef,
            pagination,
            tableHeader,
            tableData,
            getData,
            applyFilter,
            sortedCriteria,
            search,
            filterType,
            filterProgram,
            Permission,
            arrMajors,
            submit,
            formData,
            isEdit,
            idFormEdit,
            optionsPrograms,
            optionsTypeCondition,
            arrCondition,
            arrSubject,
            arrType,
        };
    },
});
